// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep .no-header {
   background-color: #ffffff;
}

.mat-row {
   cursor: pointer;
}

.browse-folder {
   display: inline-block;
   margin-right: 5px;
   width: 24px;
   height: 24px;
   vertical-align: text-bottom;
}

.toolbar {
   align-items: center;
}

.menu > li {
   float: left;
}

.menu > li + li {
   margin-left: 1em;
}

.menu > li > a {
   border: 1px solid #bdc3c7;
   border-radius: 2px;
   cursor: pointer;
   display: block;
   padding: 5px 1em;
   position: relative;
   white-space: nowrap;
}

.menu > li > a:hover {
   background-color: #f7f7f7;
   color: #3d464d;
   text-decoration: none;
}

.toolbar .dropdown.open > a {
   background-color: #ebebeb;
   border-color: #bdc3c7;
}

.menu > li > a > i {
   font-size: 16px;
   margin-right: 10px;
}

.menu button {
   padding: 0 12px;
}

.menu button.mat-primary {
   line-height: 30px;
}

.menu button:not(.mat-primary) {
   border: 1px solid #bdc3c7;
   line-height: 28px;
}

.menu button em {
   font-size: 16px;
   margin-right: 10px;
}

.separator {
   border: none;
   border-top: 1px solid #eaeaea;
   height: 0;
   margin: 5px 0;
}

.toolbar .dropdown-menu {
   left: auto;
   right: 0;
}

.file-upload {
   display: none;
   overflow: hidden;
   width: 0;
   height: 0;
}

/* Full-width inputs */
input[type=text], input[type=password], input[type=email] {
   width: 70%;
   padding: 10px 15px;
   margin: 0 0;
   display: inline-block;
   border: 1px solid #ccc;
   box-sizing: border-box;
}

.btn-x {
   margin-top: 5px;
   font-size: 18px;
}

.templatelist {
   list-style: none;
   margin: 50px 10px 10px;
   padding: 0;
   position: relative;
   transition: background-color .3s, opacity .3s;
}

.templatelist li {
   align-items: center;
   border-top: 1px solid transparent;
   border-bottom: 1px solid #eaeaea;
   margin-top: -1px;
}

.templatelist li.selected {
   background-color: rgba(0, 178, 201, 0.05);
   border-color: rgba(26, 89, 118, 0.1);
}

.tpList {
   margin: 50px 10px 10px;
   position: relative;
   transition: background-color .3s, opacity .3s;
}

.search-box {
   padding-left: 1em;
   position: relative;
}

.mat-form-field {
   font-size: 14px;
   width: 100%;
}

/*.mat-table {*/
/*overflow: auto;*/
/*height: calc(100vh - 280px);*/
/*}*/

.mat-column-select {
   overflow: visible;
}

.template-shadow {
   box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0), 0px 0px 0px 0px rgba(0, 0, 0, 0), 10px 0px 14px 0px rgba(0, 0, 0, 0.12);
}

.loading-shade {
   position: absolute;
   top: 0;
   left: 0;
   bottom: 56px;
   right: 0;
   background: rgba(0, 0, 0, 0.15);
   z-index: 1;
   display: flex;
   align-items: center;
   justify-content: center;
}

.rate-limit-reached {
   color: #980000;
   max-width: 360px;
   text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/app/e-signature/auto-approve/auto-approve.component.css"],"names":[],"mappings":"AAAA;GACG,yBAAyB;AAC5B;;AAEA;GACG,eAAe;AAClB;;AAEA;GACG,qBAAqB;GACrB,iBAAiB;GACjB,WAAW;GACX,YAAY;GACZ,2BAA2B;AAC9B;;AAEA;GACG,mBAAmB;AACtB;;AAEA;GACG,WAAW;AACd;;AAEA;GACG,gBAAgB;AACnB;;AAEA;GACG,yBAAyB;GACzB,kBAAkB;GAClB,eAAe;GACf,cAAc;GACd,gBAAgB;GAChB,kBAAkB;GAClB,mBAAmB;AACtB;;AAEA;GACG,yBAAyB;GACzB,cAAc;GACd,qBAAqB;AACxB;;AAEA;GACG,yBAAyB;GACzB,qBAAqB;AACxB;;AAEA;GACG,eAAe;GACf,kBAAkB;AACrB;;AAEA;GACG,eAAe;AAClB;;AAEA;GACG,iBAAiB;AACpB;;AAEA;GACG,yBAAyB;GACzB,iBAAiB;AACpB;;AAEA;GACG,eAAe;GACf,kBAAkB;AACrB;;AAEA;GACG,YAAY;GACZ,6BAA6B;GAC7B,SAAS;GACT,aAAa;AAChB;;AAEA;GACG,UAAU;GACV,QAAQ;AACX;;AAEA;GACG,aAAa;GACb,gBAAgB;GAChB,QAAQ;GACR,SAAS;AACZ;;AAEA,sBAAsB;AACtB;GACG,UAAU;GACV,kBAAkB;GAClB,WAAW;GACX,qBAAqB;GACrB,sBAAsB;GACtB,sBAAsB;AACzB;;AAEA;GACG,eAAe;GACf,eAAe;AAClB;;AAEA;GACG,gBAAgB;GAChB,sBAAsB;GACtB,UAAU;GACV,kBAAkB;GAClB,6CAA6C;AAChD;;AAEA;GACG,mBAAmB;GACnB,iCAAiC;GACjC,gCAAgC;GAChC,gBAAgB;AACnB;;AAEA;GACG,yCAAyC;GACzC,oCAAoC;AACvC;;AAEA;GACG,sBAAsB;GACtB,kBAAkB;GAClB,6CAA6C;AAChD;;AAEA;GACG,iBAAiB;GACjB,kBAAkB;AACrB;;AAEA;GACG,eAAe;GACf,WAAW;AACd;;AAEA,eAAe;AACf,kBAAkB;AAClB,+BAA+B;AAC/B,IAAI;;AAEJ;GACG,iBAAiB;AACpB;;AAEA;GACG,qHAAqH;AACxH;;AAEA;GACG,kBAAkB;GAClB,MAAM;GACN,OAAO;GACP,YAAY;GACZ,QAAQ;GACR,+BAA+B;GAC/B,UAAU;GACV,aAAa;GACb,mBAAmB;GACnB,uBAAuB;AAC1B;;AAEA;GACG,cAAc;GACd,gBAAgB;GAChB,kBAAkB;AACrB","sourcesContent":["::ng-deep .no-header {\n   background-color: #ffffff;\n}\n\n.mat-row {\n   cursor: pointer;\n}\n\n.browse-folder {\n   display: inline-block;\n   margin-right: 5px;\n   width: 24px;\n   height: 24px;\n   vertical-align: text-bottom;\n}\n\n.toolbar {\n   align-items: center;\n}\n\n.menu > li {\n   float: left;\n}\n\n.menu > li + li {\n   margin-left: 1em;\n}\n\n.menu > li > a {\n   border: 1px solid #bdc3c7;\n   border-radius: 2px;\n   cursor: pointer;\n   display: block;\n   padding: 5px 1em;\n   position: relative;\n   white-space: nowrap;\n}\n\n.menu > li > a:hover {\n   background-color: #f7f7f7;\n   color: #3d464d;\n   text-decoration: none;\n}\n\n.toolbar .dropdown.open > a {\n   background-color: #ebebeb;\n   border-color: #bdc3c7;\n}\n\n.menu > li > a > i {\n   font-size: 16px;\n   margin-right: 10px;\n}\n\n.menu button {\n   padding: 0 12px;\n}\n\n.menu button.mat-primary {\n   line-height: 30px;\n}\n\n.menu button:not(.mat-primary) {\n   border: 1px solid #bdc3c7;\n   line-height: 28px;\n}\n\n.menu button em {\n   font-size: 16px;\n   margin-right: 10px;\n}\n\n.separator {\n   border: none;\n   border-top: 1px solid #eaeaea;\n   height: 0;\n   margin: 5px 0;\n}\n\n.toolbar .dropdown-menu {\n   left: auto;\n   right: 0;\n}\n\n.file-upload {\n   display: none;\n   overflow: hidden;\n   width: 0;\n   height: 0;\n}\n\n/* Full-width inputs */\ninput[type=text], input[type=password], input[type=email] {\n   width: 70%;\n   padding: 10px 15px;\n   margin: 0 0;\n   display: inline-block;\n   border: 1px solid #ccc;\n   box-sizing: border-box;\n}\n\n.btn-x {\n   margin-top: 5px;\n   font-size: 18px;\n}\n\n.templatelist {\n   list-style: none;\n   margin: 50px 10px 10px;\n   padding: 0;\n   position: relative;\n   transition: background-color .3s, opacity .3s;\n}\n\n.templatelist li {\n   align-items: center;\n   border-top: 1px solid transparent;\n   border-bottom: 1px solid #eaeaea;\n   margin-top: -1px;\n}\n\n.templatelist li.selected {\n   background-color: rgba(0, 178, 201, 0.05);\n   border-color: rgba(26, 89, 118, 0.1);\n}\n\n.tpList {\n   margin: 50px 10px 10px;\n   position: relative;\n   transition: background-color .3s, opacity .3s;\n}\n\n.search-box {\n   padding-left: 1em;\n   position: relative;\n}\n\n.mat-form-field {\n   font-size: 14px;\n   width: 100%;\n}\n\n/*.mat-table {*/\n/*overflow: auto;*/\n/*height: calc(100vh - 280px);*/\n/*}*/\n\n.mat-column-select {\n   overflow: visible;\n}\n\n.template-shadow {\n   box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0), 0px 0px 0px 0px rgba(0, 0, 0, 0), 10px 0px 14px 0px rgba(0, 0, 0, 0.12);\n}\n\n.loading-shade {\n   position: absolute;\n   top: 0;\n   left: 0;\n   bottom: 56px;\n   right: 0;\n   background: rgba(0, 0, 0, 0.15);\n   z-index: 1;\n   display: flex;\n   align-items: center;\n   justify-content: center;\n}\n\n.rate-limit-reached {\n   color: #980000;\n   max-width: 360px;\n   text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
